import React from 'react';
import { Grid } from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  DatePicker as DatePickerMUI,
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { APP_PRIMARY } from 'colours';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiInputBase-input': {
      fontSize: '20px',
      color: APP_PRIMARY,
      fontWeight: 600,
      textAlign: 'center',
      maxWidth: 100,
    },
  },
}));

export default function DatePicker(props) {
  const classes = useStyles();

  const getOpenTo = () => {
    if (
      props.minDate &&
      props.maxDate &&
      props.minDate.getYear() === props.maxDate.getYear()
    ) {
      return 'month';
    } else {
      return 'year';
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
        <DatePickerMUI
          clearable
          className={classes.root}
          views={['year', 'month']}
          placeholder="MM/yyyy"
          maxDate={new Date()}
          format="MM/yyyy"
          disableToolbar
          {...props}
          value={props.value}
          openTo={getOpenTo()}
          onChange={props.onChange}
        />
      </Grid>
    </MuiPickersUtilsProvider>
  );
}

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
